import { useParams } from 'react-router-dom';
import { ProfileDashboard } from '../../pages/ProfileDashboard';
import { CreditCanpaign } from './components/CreditCampaign/CreditCampaign';
import { Credit } from './components/Credit/Credit';
import { SuppConstantsForpo } from '../../bpm/config/Componentes/Hooks/SuppConstants/SuppConstantsForpo';
import { StoreCategory } from './components/TiendaVirtual/StoreCategory';
import { StoreItem } from './components/TiendaVirtual/StoreItem';
import { Comiteroles } from '../../bpm/config/Componentes/Hooks/SuppConstants/Comiteroles';
import { Policy } from './components/Policy/Policy';
import { Portalterceros } from './components/Portalterceros/Portalterceros';
import { MediaSlide } from './components/MediaSlide/MediaSlide';
import { Intro } from './components/Intro/Intro';
import { InternalMenu } from './components/InternalMenu/InternalMenu';
import { Comite } from './components/ComitCredits/Comite';
import { AmortizationType } from '../../admin/CreditPotfolio/AmortizationType/AmortizationType';
import { QuotaTimeTerm } from '../../admin/CreditPotfolio/QuotaTimeTerm/QuotaTimeTerm';
import { PayrollEntity } from '../../admin/CreditPotfolio/PayrollEntity/PayrollEntity';
import { LoanCurrency } from '../../Talentohumano/GestionTH/EmployeeContract/LoanDestination/LoanCurrency/LoanCurrency';
import { LoanDestination } from '../../admin/CreditPotfolio/LoanDestination/LoanDestination';
import { ThirdLoanEntity } from '../../admin/CreditPotfolio/ThirdLoanEntity/ThirdLoanEntity';
import { LoanTimeTerm } from '../../admin/CreditPotfolio/LoanTimeTerm/LoanTimeTerm';
import { LoanLine } from '../../admin/CreditPotfolio/LoanLine/LoanLine';
import { LoanAccountantConcept } from '../../admin/CreditPotfolio/LoanAccountantConcept/LoanAccountantConcept';
import { CreditOpening } from '../../admin/CreditPotfolio/CreditOpening/CreditOpening';
import { DocumentAffiliate } from '../../erp/DocumentAffiliate/DocumentAffiliate';
import { CreditProperties } from '../../erp/CreditProperties/CreditProperties';
import { CreditRoleGroup } from '../../erp/CreditRoleGroup/CreditRoleGroup';
import { RequestCredit } from './components/Credit/RequestCredit';
import { CreditAccountvdos } from '../../Talentohumano/GestionTH/EmployeeContract/CreditAccount/CreditAccount';
import { CreditAffiliate } from '../../Talentohumano/GestionTH/EmployeeContract/AfilliateCreditList/CreditAffiliate';
import { ComiteCredito } from '../../Talentohumano/GestionTH/EmployeeContract/Comite/ComiteCredito';
import { BandejaSolicitudCredito } from '../../Talentohumano/GestionTH/EmployeeContract/Comite/BandejaSolicitudCredito';
import { ActaComite } from './components/ActaComite/ActaComite';
import { ProcessCredit } from './components/Credit/Procesos/ProcessCredit';
import { LoanConfigProfile } from './components/Credit/Procesos/LoanConfigProfile';
import { PagoDescuentoNomina } from './components/Credit/Procesos/PagoDescuentoNomina';
import { PagoDescuentoNominaTercero } from './components/Credit/Procesos/PagoDescuentoNominaTercero';
import { ThirdCreditsInforpo } from '../../admin/CreditPotfolio/ThirdCreditsInforpo/ThirdCreditsInforpo';
import { ReportDiscountsByEmployee } from '../../admin/CreditPotfolio/ReportDiscountsByEmployee/ReportDiscountsByEmployee';
import { ThirdContactInfo } from '../../admin/CreditPotfolio/ThirdContactInfo/ThirdContactInfo';
import { ImportBankingAbstractAccount } from '../../admin/CreditPotfolio/ImportBankingAbstractAccount/ImportBankingAbstractAccount';
import { PortfolioDeterioration } from './components/Credit/Procesos/PortfolioDeterioration';
import { RequestCreditInfo } from '../../admin/CreditPotfolio/ThirdContactInfo/RequestCreditInfo/RequestCreditInfo';
import { AccountCreditSimulator } from '../../Talentohumano/GestionTH/EmployeeContract/CreditAccount/AccountCreditSimulator/AccountCreditSimulator';
import { ImportAbstractAccount } from '../../admin/CreditPotfolio/ImportBankingAbstractAccount/ImportAbstractAccount';
import { PaymentFiles } from './components/Credit/Procesos/PaymentFiles';
import { ThirdContactCreditInfo } from '../../admin/CreditPotfolio/ThirdContactCreditInfo/ThirdContactCreditInfo';
import { EstructuredCredit } from '../../admin/CreditPotfolio/EstructuredCredit/EstructuredCredit';
import { DeudorCapacity } from '../../admin/CreditPotfolio/DeudorCapacity/DeudorCapacity';


export const CreditRouter = (props: any) => {
  const { module, view }: any = useParams();


  const renderSwitch = (url: string) => {
    switch (url) {
      case "tipo-amortizacion":
        return <AmortizationType />;
      case "tipo-cuota":
        return <QuotaTimeTerm />;
      case "documentos-requisitos":
        return <DocumentAffiliate />;
      case "parametricas-credito":
        return <CreditProperties />;
      case "funcionario-credito":
        return <CreditRoleGroup />;
      case "entidades-creditos-administrados":
        return <ThirdLoanEntity />;
      case "cajas-nominadoras":
        return <PayrollEntity />;
      case "credito-lineas":
        return <LoanLine />;
      case "apertura-credito":
        return <CreditOpening />;
      case "concepto-contable-presupuestal":
        return <LoanAccountantConcept />;
      case "credit-line":
        return <CreditCanpaign />;
      case "credit":
        return <Credit />;
      case "comite":
        return <Comite />;
      case "parameters":
        return <SuppConstantsForpo />;
      case "portalterceros":
        return <Portalterceros />;
      case "category-store":
        return <StoreCategory />;
      case "item-store":
        return <StoreItem />;
      case "comite-roles":
        return <Comiteroles />;
      case "policy":
        return <Policy />;
      case "tipo-moneda":
        return <LoanCurrency />;
      case "destino-credito":
        return <LoanDestination />;
      case "tipos-palzos-credito":
        return <LoanTimeTerm />;
      case "bandeja-cartera":
        return <CreditAccountvdos />;
      case "media-slide":
        return <MediaSlide />;
      case "introforpo":
        return <Intro />;
      case "internal-menu":
        return <InternalMenu />;
      case "request-credit":
        return <RequestCredit />;
      case "afiliados-info":
        return <CreditAffiliate />;
      case "comite-credito":
        return <ComiteCredito />;
      case "bandeja-solicitud-credito":
        return <BandejaSolicitudCredito />;
      case "acta-credito":
        return <ActaComite />;
      case "process-credit":
        return <ProcessCredit />;
      case "loan-config-profile":
        return <LoanConfigProfile />;
      case "aplicar-descuento-nomina":
        return <PagoDescuentoNomina />;
      case "aplicar-descuento-nomina-tercero":
        return <PagoDescuentoNominaTercero />;
      case "creditos-tercero-inforpo":
        return <ThirdCreditsInforpo />;
      case "reporte-descuentos-nomina-empleado":
        return <ReportDiscountsByEmployee />;
      case "informacion-contacto":
        return <ThirdContactInfo />;
      case "consulta-tercero":
        return <ThirdContactCreditInfo />;
      case "importar-cuentas-bancarias":
        return <ImportBankingAbstractAccount />;
      case "archivo-recaudo":
        return <PaymentFiles />;
      case "portfolio-deterioration":
        return <PortfolioDeterioration />;
      case "registros-comunicacion":
        return <RequestCreditInfo />;
      case "estructuracion-credito":
        return <EstructuredCredit />;
      case "capacidad-credito":
        return <DeudorCapacity />;
      case "credit-simulator":
        return <AccountCreditSimulator componentForma='Menu' />;
      default:
        return <ProfileDashboard />;
    }
  };

  return (

    <div className="" >
      {renderSwitch(view)}
    </div>

  )

}